import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";
import { formatMoney, SITE_CONFIG } from "../config/siteConfig";

function Delivery() {
  return (
    <PolicyLayout
      title="Shipping and delivery policy"
      intro={`This policy covers the physical products offered by ${SITE_CONFIG.brand}. Each checkout adds one ${formatMoney(SITE_CONFIG.shippingFee)} shipping charge.`}
    >
      <section>
        <h2>Eligible destinations and address review</h2>
        <p>An order can be submitted only for a country or region available in the checkout selector. The buyer must provide a complete recipient name, street address, city and postal code where one applies, plus an email that can receive order questions. Required-field validation does not establish that an address is deliverable.</p>
        <p>Send an address correction with the order number as soon as the error is found. A correction can be applied only while the parcel can still be redirected within the fulfilment process.</p>
      </section>

      <section>
        <h2>Shipping charge and parcel preparation</h2>
        <p>The fixed shipping charge is shown separately from the merchandise subtotal before payment. Mixed-product orders still receive one checkout shipping charge. Payment must be verified and the order details reviewed before goods enter dispatch preparation.</p>
        <p>Fragile pieces and bottles are separated and cushioned; liquids and food remain in their primary sealed packaging; textiles and paper lighting are protected from moisture; sharp accessories are secured against movement. More than one parcel may be used where combining incompatible shapes or risks would make a shipment unsafe.</p>
      </section>

      <section>
        <h2>Delivery handover</h2>
        <p>The recipient is responsible for providing access to the stated delivery point and completing any lawful identity, age or import check that applies to the parcel. Alcohol may be handed over only where the sale and receipt comply with the destination's requirements. Failed handover caused by an address or eligibility problem is investigated before any redelivery or return arrangement is made.</p>
      </section>

      <section>
        <h2>Inspecting the parcel</h2>
        <p>At receipt, check the outer parcel for crushing, puncture or leakage before discarding it. Open fragile and liquid goods carefully, keep the shipping label and packing materials, and stop using any cracked, leaking, unsealed or electrically damaged item. Follow the <Link to="/delivery-issues">delivery problems procedure</Link> for a missing, delayed, damaged, incomplete or incorrect parcel.</p>
      </section>

      <section>
        <h2>Mandatory protections</h2>
        <p>Delivery and packaging rules do not remove a remedy that cannot be excluded for goods that are unsafe, materially different from their description, damaged in transit or incorrectly supplied.</p>
      </section>
    </PolicyLayout>
  );
}

export default Delivery;
